"use client"

import { useNavigate } from "react-router-dom"
import { ArrowLeft } from "lucide-react"

interface BackButtonProps {
  className?: string
  label?: string
}

export default function BackButton({ className = "" }: { className?: string }) {
  const navigate = useNavigate()

  return (
    <button
      onClick={() => navigate(-1)}
      aria-label="Go back"
      className={`group flex items-center justify-center w-10 h-10 rounded-full border border-slate-200 bg-white/80 backdrop-blur-sm text-slate-900 shadow-sm hover:border-[#b48c36] hover:text-[#b48c36] hover:shadow-md transition-all duration-300 ${className}`}
    >
      <ArrowLeft size={20} strokeWidth={2.5} className="group-hover:-translate-x-0.5 transition-transform" />
    </button>
  )
}
